<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { ref } from 'vue'

import { type ListItemInterface } from '../../../components/ui/list'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '.'

defineOptions({ inheritAttrs: true })

export type DropdownProperties = {
  items?: ListItemInterface[]
  hover?: boolean
}

// eslint-disable-next-line unicorn/prevent-abbreviations
const props = withDefaults(defineProps<DropdownProperties>(), {
  items: () => [],
  hover: false,
})

export interface DropdownEmits {
  (event: 'click', id: number): void
}

defineEmits<DropdownEmits>()

const toggleOpen = ref<boolean>(false)
</script>

<template>
  <DropdownMenu v-model:open="toggleOpen">
    <DropdownMenuTrigger><slot /></DropdownMenuTrigger>
    <DropdownMenuContent class="atabix-dropdown__content">
      <template v-for="(item, index) in props.items" :key="index">
        <DropdownMenuSeparator v-if="item.seperator" />
        <DropdownMenuItem :item="item" />
      </template>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<style lang="scss">
.atabix-dropdown__content {
  @apply -right-5 top-0 w-full md:absolute md:w-auto;
}
</style>
